import React, { Component } from "react";
import Background from '../styles/images/loader.gif';

var loaderStyle = {
    backgroundImage: `url(${Background})`,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
};

export default class InvoiceFramePDF extends Component {
    render() {
        console.log('this', this.props.modalShow)
        if (!this.props.modalShowPDF) {
            return <div></div>
        }
        else {
        return (
            <div style={loaderStyle} id="removeModalPDF">
                <iframe src={this.props.src} height={this.props.height} width={this.props.width} className="fullheight" title="Invoice" />
            </div>
            )
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/InvoicePDFModal.js